import { fetchAuthSession } from 'aws-amplify/auth';
import { apiClient } from '@/lib/api-client';
import { getAccessToken } from '@/utils/auth';
import type { UserContextsResponse } from './types';

export const fetchUserContexts = async (): Promise<UserContextsResponse> => {
  const session = await fetchAuthSession();
  const token = getAccessToken(session);
  const response = await apiClient.get('users/user-contexts/contexts', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
